export const isDateInRange = (dateFrom, dateTo, dateToBeFiltered) => {
  if (!dateToBeFiltered) {
    return !(dateFrom || dateTo);
  }
  const parsedDateToFilter = new Date(dateToBeFiltered).setHours(0, 0, 0, 0);

  if (!(dateFrom || dateTo)) {
    return true;
  } else if (!dateFrom) {
    return parsedDateToFilter <= new Date(dateTo).setHours(0, 0, 0, 0);
  } else if (!dateTo) {
    return parsedDateToFilter >= new Date(dateFrom).setHours(0, 0, 0, 0);
  }
  return (
    parsedDateToFilter >= new Date(dateFrom).setHours(0, 0, 0, 0) &&
    parsedDateToFilter <= new Date(dateTo).setHours(0, 0, 0, 0)
  );
};
